import React from 'react'
import { connectCurrentRefinements } from 'react-instantsearch-dom'

const FilterRefinements = ({ items, refine, text, className, filter }) => {
  return (
    <div
      className={className}
      onClick={() => { refine(items.filter(filter)) }}
    >
      { text }
    </div>
  )
}

const FilterFilters = connectCurrentRefinements(FilterRefinements)

export default FilterFilters
